export default __webpack_public_path__ + "static/media/download.6155f339.svg";